import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 -960 960 960"

const BoxIcon = createSvgIcon(
  <>
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M186.67-662.67v476h586.66v-476H640V-328l-160-80-160 80v-334.67H186.67Zm0 542.67q-27.5 0-47.09-19.58Q120-159.17 120-186.67v-519q0-11.25 3.5-21.7t10.5-19.3l51.33-67.66q9-12 23.13-18.84Q222.59-840 238-840h483.33q15.42 0 29.54 6.83Q765-826.33 774-814.33l52 67.66q7 8.85 10.5 19.3 3.5 10.45 3.5 21.7v519q0 27.5-19.58 47.09Q800.83-120 773.33-120H186.67Zm16.66-609.33H756l-35.61-44H238.67l-35.34 44Zm183.34 66.66V-436L480-482.67 573.33-436v-226.67H386.67Zm-200 0H773.33 186.67Z'
    />
  </>,
  'BoxIcon'
)

export default BoxIcon
